import { render, staticRenderFns } from "./DialogRuleMain.vue?vue&type=template&id=f0e52aa4&lang=pug"
import script from "./DialogRuleMain.vue?vue&type=script&lang=js"
export * from "./DialogRuleMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports